import type { Work } from "@/types";

export default function WorkCard({ work }: { work: Work }) {
  const finished = work.status === "已完结";
  return (
    <article className="group flex flex-col rounded-lg border border-background-200/70 bg-background-50 overflow-hidden hover:border-primary-300 transition-colors">
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={work.cover}
          alt={`《${work.title}》漫画封面`}
          title={`${work.title} 漫画 免费在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute top-2 left-2 rounded-md text-xs px-2 py-0.5 backdrop-blur-sm ${
            finished ? "bg-secondary-500/90 text-background-50" : "bg-accent-500/90 text-background-50"
          }`}
        >
          {work.status}
        </span>
        <span className="absolute bottom-2 right-2 inline-flex items-center gap-1 rounded-md bg-background-950/70 text-background-50 text-xs px-2 py-0.5">
          <i className="ri-star-fill text-primary-300" aria-hidden="true"></i>
          {work.rating}
        </span>
      </div>

      <div className="flex flex-col gap-2 p-4 flex-1">
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span className="rounded-full bg-primary-100 text-primary-700 px-2 py-0.5 whitespace-nowrap">{work.category}</span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-eye-line" aria-hidden="true"></i>
            {work.views}
          </span>
        </div>

        <h3 className="font-medium text-foreground-950 text-sm md:text-base leading-snug line-clamp-1">
          {work.title}
        </h3>

        <p className="text-foreground-600 text-xs md:text-sm leading-relaxed line-clamp-2">{work.description}</p>

        <div className="mt-auto pt-2 flex flex-wrap gap-1.5">
          {work.genres.map((g) => (
            <span key={g} className="rounded-full bg-secondary-100 text-secondary-900 text-[11px] px-2 py-0.5 whitespace-nowrap">
              {g}
            </span>
          ))}
        </div>

        <div className="flex items-center justify-between pt-2 border-t border-background-200/70 text-xs text-foreground-500">
          <span className="truncate">{work.author}</span>
          <span className="whitespace-nowrap">{work.latestChapter}</span>
        </div>
      </div>
    </article>
  );
}